import React from 'react';
import type { BadgeType } from '../config/permissions';

interface WidgetBadgeProps {
  type: BadgeType;
  size?: 'sm' | 'md'; // sm for title bars, md for modal cards
}

// Color scheme per badge type
// Brand spec: badges/pills are "hue @ 16% alpha background + solid hue text".
// `new` was emerald — dropped, since the spec allows no green anywhere.
// `beta` was stock blue-500, which read as a second, unrelated blue next to
// the Up/Call blue; it now uses the brand token.
const BADGE_STYLES: Record<BadgeType, { bg: string; text: string }> = {
  admin: { bg: 'bg-violet-500/16', text: 'text-violet-400' },
  beta: { bg: 'bg-bull-blue/16', text: 'text-bull-blue' },
  new: { bg: 'bg-accent-yellow/16', text: 'text-accent-yellow' },
  updated: { bg: 'bg-wheat/16', text: 'text-wheat' },
};

const BADGE_LABELS: Record<BadgeType, string> = {
  admin: 'Admin',
  beta: 'Beta',
  new: 'New',
  updated: 'Updated',
};

export const WidgetBadge: React.FC<WidgetBadgeProps> = ({ type, size = 'sm' }) => {
  const styles = BADGE_STYLES[type];
  const label = BADGE_LABELS[type];

  const sizeClasses = size === 'sm' ? 'px-1.5 py-0.5 text-[10px]' : 'px-2 py-0.5 text-xs';

  return (
    <span className={`${styles.bg} ${styles.text} ${sizeClasses} font-medium rounded-full`}>
      {label}
    </span>
  );
};
